import React from "react";
import Invoices from "./Invoices";

const PurchaseInvoices: React.FC = () => {
  return <Invoices type="purchase" />;
};

export default PurchaseInvoices;
